export const DEFAULT_DATE_FORMAT = 'yyyy.MM.dd'
